// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2KsEw","imageUploader":"EGiftCard_imageUploader__1ZXCs"};